export class Offer {
    id: number = 0;
    title: string = '';
    description: string = '';
    end: string = '';
    picture: string = '';
    categories: [] = [];
    region: any = '';
}